var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{ref:"chart",attrs:{"styles":_vm.myStyles}})}
var staticRenderFns = []

export { render, staticRenderFns }